/* ★ CUBA SEMULA AUTOMATIK — larian pukal My Agent (2026-10-24)
 *
 * Aduan pelanggan hb.izyan@gmail.com (24 Okt): tick banyak kad → hanya kad PERTAMA
 * masuk, kad lain gagal; run satu-satu → semua masuk. Diukur pada log kad: kad yang
 * gagal membawa "A listener indicated an asynchronous response … message channel
 * closed" — service worker extension mati di tengah tugasan, ChatGPT tetap siap
 * menjawab tetapi jawapan tiada siapa yang ambil. Run semula kad yang sama = lepas.
 *
 * Fail ini menentukan ralat mana yang SELAMAT dicuba semula SEKALI di hujung larian
 * (keputusan user 24 Okt: "cuba semula automatik", bulk-first). Hanya ralat
 * sambungan / tiada jawapan — BUKAN:
 *   - tamat masa (larian sudah menunggu minit-minit; tab lama mungkin masih menulis),
 *   - "Dihentikan oleh pengguna",
 *   - ralat tetapan (Allow user scripts, gate, gambar ditolak dll.) — ulang = gagal sama.
 *
 * ⚠️ KEMBAR: punca sebenar dibaiki di extension (`background.ts` DIRECT_CHATGPT_TASK —
 *    heartbeat kekalkan service worker hidup, BUNDLED → naik dengan ZIP). Fail ini jaring
 *    untuk extension lama + kes yang masih terlepas.
 *
 * ⛔ Fungsi TULEN (tiada import) — diuji dengan
 *    `node --test src/utils/cubaSemulaAgent.test.js`.
 */

const CORAK_CUBA_SEMULA = [
    /message channel closed/i,                 // service worker extension mati di tengah tugasan
    /Tiada jawapan daripada (ChatGPT|Gemini)/i, // jawapan tidak muncul dalam halaman
    /Content script tidak responsif/i,         // tab ChatGPT/Gemini lambat dimuat
    /Tabs cannot be edited right now/i,        // Chrome sibuk (pelanggan sedang seret tab)
    /Kotak taip (ChatGPT|Gemini) tidak dijumpai/i, // halaman belum siap dilukis
];

/** Ralat tugasan agent yang patut dicuba semula sekali (string mentah daripada extension). */
export const bolehCubaSemulaAgent = (ralat) => {
    const s = String(ralat || '');
    if (!s.trim()) return false;
    return CORAK_CUBA_SEMULA.some(re => re.test(s));
};

/** Jeda sebelum cubaan semula — beri masa service worker bangun semula. */
export const JEDA_CUBA_SEMULA_MS = 3000;
